import React, { useState } from "react";
import { Box, Text } from "@chakra-ui/react";
import Modal from "react-modal";
import { FaTimes } from "react-icons/fa";
import { SearchInput } from "../../../components/SearchInput";
import { CardLoja } from "../../../components/CardLoja";
import { useRecomendacao } from "../../../context/useRecomendacao";

export function Lojas({ isOpen, onRequestClose }) {
  const { handleChangeLoja, lojas } = useRecomendacao();

  const [filterText, setFilterText] = useState("");
  const [lojasFiltered, setLojasFiltered] = useState([]);

  function selectLoja(loja) {
    handleChangeLoja(loja);
    onRequestClose();
  }

  function update(text) {
    const newLojas = lojas;
    var res = newLojas.filter(function (loja) {
      return (
        loja.nome.toUpperCase().indexOf(text.toUpperCase()) >= 0 ||
        loja.endereco.toUpperCase().indexOf(text.toUpperCase()) >= 0
      );
    });

    setLojasFiltered(res);
  }

  return (
    <Modal
      className="react-modal-content-lojas"
      overlayClassName="react-modal-overlay-lojas"
      isOpen={isOpen}
      onRequestClose={onRequestClose}
    >
      <Box
        display="flex"
        flexDir="column"
        position="fixed"
        background="white"
        maxWidth="900px"
        width="100%"
        padding="1rem"
        borderTopRadius="10px"
        zIndex="sticky"
      >
        <Box display="flex" alignItems="center">
          <button
            type="button"
            onClick={onRequestClose}
            className="react-modal-close-lojas"
          >
            <FaTimes color="#3E4047" size={18} />
          </button>
          <Text
            color="#3E4047"
            fontSize="md"
            fontWeight="medium"
            marginLeft="1.5rem"
          >
            Selecione uma loja
          </Text>
        </Box>

        <Box marginTop="1.5rem">
          <SearchInput
            defaultValue={filterText}
            placeholder="Buscar por loja ou endereço"
            onChange={(text) => {
              update(text.target.value);
              setFilterText(text.target.value);
            }}
          />
        </Box>
      </Box>

      <Box padding="1rem" marginTop="6.5rem">
        {lojasFiltered.length > 0 || filterText !== ""
          ? lojasFiltered.map((data, index) => (
              <Box marginTop="1.5rem" key={index}>
                <CardLoja props={data} onClick={() => selectLoja(data)} />
              </Box>
            ))
          : lojas.map((data, index) => (
              <Box marginTop="1.5rem" key={index}>
                <CardLoja props={data} onClick={() => selectLoja(data)} />
              </Box>
            ))}
      </Box>
    </Modal>
  );
}
